import App from '@components/avatar/App.vue'
import { generateApplication } from '@helpers/generate_component.js';

generateApplication(App, "#avatar", [{ name: '$contact', module: contact }])